<template>
  <v-layout row wrap justify-space-between>
    <v-flex xs12 md6 lg5>
      <v-flex xs12>
        <v-text-field
          label="Nombre"
          :value="visit.name"
          prepend-icon="title"
          rows="1"
          row-height="24"
          auto-grow
          disabled
        />
      </v-flex>

      <v-list>
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon class="red--text">person</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>Colaborador</v-list-tile-title>
            <v-list-tile-sub-title v-if="collaborator">
              {{ collaborator.firstName }} {{ collaborator.lastName }}
            </v-list-tile-sub-title>
            <v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon class="red--text">subject</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>Motivo</v-list-tile-title>
            <v-list-tile-sub-title v-if="visit.reason">
              {{ visit.reason }}
            </v-list-tile-sub-title>
            <v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon class="red--text">event</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>Fecha</v-list-tile-title>
            <v-list-tile-sub-title v-if="visit.date">
              {{ visit.date | formatDate }}
            </v-list-tile-sub-title>
            <v-list-tile-sub-title v-else>---</v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-flex xs12 v-if="visit.peopleMode === 'AUDIENCE'">
          <v-btn
            @click="viewAudiency"
            class="red--text"
            outlined
            flat
            style="text-transform: none"
          >
            <v-icon left>remove_red_eye</v-icon> Ver Audiencia
          </v-btn>
        </v-flex>
      </v-list>
    </v-flex>

    <v-flex xs12 md4 offset-md2 justify-space-between>
      <v-layout row wrap align-center justify-space-between>
        <v-flex xs12 md12 v-if="people.parents.length > 0">
          <v-list subheader two-line dense>
            <v-subheader>Tutores</v-subheader>
            <template v-for="(item, index) in people.parents">
              <v-list-tile :key="index" avatar>
                <v-list-tile-avatar>
                  <v-icon>account_circle</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title
                    v-html="item.firstName + ' ' + item.lastName"
                  ></v-list-tile-title>
                  <v-list-tile-sub-title
                    v-html="item.mail"
                  ></v-list-tile-sub-title>
                  <v-divider :key="index" :inset="true"></v-divider>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
        </v-flex>
        <v-flex xs12 md12 v-if="people.externs.length > 0">
          <v-list subheader two-line dense>
            <v-subheader>Invitados externos</v-subheader>
            <template v-for="(item, index) in people.externs">
              <v-list-tile :key="index" avatar>
                <v-list-tile-avatar>
                  <v-icon>account_circle</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title
                    v-html="item.firstName + ' ' + item.lastName"
                  ></v-list-tile-title>
                  <v-list-tile-sub-title
                    v-html="item.email"
                  ></v-list-tile-sub-title>
                  <v-divider :key="index" :inset="true"></v-divider>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
        </v-flex>
      </v-layout>
      <v-divider class="mt-3 mb-4" v-if="people.parents.length > 0 || people.externs.length > 0"/>
      <v-layout row wrap justify-space-between>
        <v-flex md5 lg5>
          <v-img :src="require('@/assets/polls/SKLB-Encuestas.png')" />
        </v-flex>
      </v-layout>
    </v-flex>
    <AudiencyModal
      v-model="modals.showAudiency"
      :payment="visit"
      :institutional="visit.institutional"
      @onClosed="onCancel"
    />
  </v-layout>
</template>

<script>
import AudiencyModal from "../../Modals/DetailAudiency.vue";
export default {
  components: {
    AudiencyModal,
  },
  props: ["visit", "people", "collaborator"],
  data: () => ({
    modals: {
      showAudiency: false,
    },
  }),
  methods: {
    viewAudiency() {
      this.modals.showAudiency = true;
    },
    onCancel() {
      this.modals.showAudiency = false;
      this.$emit("closedPopup");
    },
  },
  filters: {},
  computed: {},
};
</script>

<style>
</style>